import script from "./ConfirmModalApprove.vue?vue&type=script&lang=ts&setup=true"
export * from "./ConfirmModalApprove.vue?vue&type=script&lang=ts&setup=true"

import "./ConfirmModalApprove.vue?vue&type=style&index=0&id=2f0ad809&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src3182222765/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2f0ad809"]])

export default __exports__